/**
 * How the address box offers a street's numbers, for this person: under the street in the
 * list, or after the street once it is picked.
 *
 * Beside the entrances in the person's menu, and kept the same way: on the membership, so it
 * follows the dispatcher to the next desk. A dispatcher's own way of working rather than the
 * firm's, so there is no firm default to follow — the list is everyone's until they choose.
 */

import { useTranslation } from 'react-i18next';

import { Select } from '../ui';
import { useNumberWay, type NumberWay } from './numberWay';
import { usePreferences } from './preferencesContext';

export function NumbersSelect({ className = 'w-auto' }: { className?: string }) {
  const { t } = useTranslation();
  const { save } = usePreferences();
  const chosen = useNumberWay();

  return (
    <Select
      value={chosen}
      onChange={(event) => save({ numbers: event.target.value as NumberWay })}
      aria-label={t('person.numbers')}
      className={className}
    >
      <option value="list">{t('person.numbersWay.list')}</option>
      <option value="after">{t('person.numbersWay.after')}</option>
    </Select>
  );
}
